import { HelpCircle } from "lucide-react";

/**
 * Ícono de ayuda con tooltip que aparece al hacer hover o focus.
 * Uso:
 *   <HelpHint>Ejemplo: 12345678-9 (con dígito verificador)</HelpHint>
 */
export default function HelpHint({ children, className = "", size = 13 }) {
  return (
    <span className={`relative inline-flex group align-middle ${className}`} tabIndex={0} data-testid="help-hint">
      <HelpCircle
        size={size}
        className="text-muted-foreground/70 hover:text-amber-300 focus:text-amber-300 cursor-help"
      />
      <span className="pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50 hidden group-hover:block group-focus-within:block whitespace-normal min-w-[220px] max-w-xs px-3 py-2 rounded-md border border-amber-400/40 bg-slate-950/95 backdrop-blur text-[11px] text-amber-100 shadow-xl">
        {children}
        <span className="absolute left-1/2 -translate-x-1/2 top-full w-2 h-2 rotate-45 bg-slate-950 border-r border-b border-amber-400/40 -mt-1"/>
      </span>
    </span>
  );
}
